<div class="modal-body">
    <div class="row">
      <div class="col-lg-12">
        <h5>Dates et Lieux</h5>
        <p>
         Choisissez le forum qui se déroule au plus proche de chez vous !
        </p>
      </div>

      <div class="col-12 form-group">
        <!-- <label for="lieu">Par quelle date êtes-vous intéressé ?</label> -->
          <div class="row">
              <div class="col-lg-4" *ngFor="let item of lieux">
                  <div class="card" >
                      <!-- <img src="..." class="card-img-top" alt="..."> -->
                      <div class="card-body">
                        <h5 class="card-title">{{item.title}}</h5>
                        <p class="card-text smallDescription" >{{ item.dateDebut | date:'EEEE d MMMM'}}</p>
                        <p class="card-text smallDescription" [innerHtml]="item.smallDescription"></p>
                        <!-- <p class="card-text" [innerHtml]="item.description"></p> -->
                        <p class="card-text description" style="white-space:pre-wrap;">{{item.description}}</p>
                        <button class="btn" (click)="selectItem(item)" *ngIf="!isSelectedItem(item)">Choisir</button>
                        <button class="btn btn-success" (click)="unselectItem(item)" *ngIf="isSelectedItem(item)">Choisi <i class="fa fa-check"></i></button>
                      </div>
                    </div>
              </div>
          </div>
  
          </div>
    </div>
  </div>
  
  <div class="modal-footer">

    <div *ngIf="currentUser">
      <div class="">
        connecté en tant que {{ currentUser.username }}
        <i class="fa fa-user"></i>
      </div>
    </div>
      <button class="btn btn-danger btn-b" type="button" (click)="prevStep()">
        retour
      </button>
      <button class="btn btn-b" [class.btn-success]="canNextStep" type="button" (click)="nextStep()">Continuer <i class="fa fa-warning" *ngIf="!canNextStep"></i></button>
    </div>
    